<template>
    <v-container max-width="100%" style="margin-top: 2%;">

        <v-dialog v-model="confirmDialog" max-width="60%" style="z-index: 10;">
            <v-card>
                <v-card-title style="color: red;">{{ $t('button.validate') }}</v-card-title>
                <v-card-text style="color: red">{{ confirmMessage }}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" dark @click="closeConfirmDialog">{{ $t('button.cancel') }}</v-btn>
                    <v-btn color="red" dark @click="deleteFromDatabase">{{ $t('button.delete') }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
      
        <merus-data-table
        :headers="headersWithProperties"
        :items="trechos"
        :loading="loading"
        :loading-text="$t('segments.loading')"
        dense
        class="elevation-7"
        locale="pt"
        style="border-radius: 10px; margin-top: 10px;"
        item-key="id_trecho"
        show-expand
        :single-expand="true"
        cod-tabela="TRECHOS"
        actions-i18n-key="segments.headers.actions"
        @update:headers="headersWithProperties = $event"
        >
        <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length" style="margin: 0;padding: 5px;">
                <v-data-table
                    :headers="expandedLimitesHeaders"
                    :items="item.limites"
                    dense
                    locale="pt"
                    hide-default-footer
                    disable-pagination
                    :loading-text="$t('segments.loadingLimits')"
                >
                <template v-slot:top>
                    <CadastroToolbar
                        :title="$t('segments.timeLimits')"
                        :token="token"
                        :items="item.limites"
                        hide-search
                    />
                </template>
                <template v-slot:item.actions="{ item }">
                    <v-icon small class="mr-2" color="green" @click="editItem(item)"
                    >mdi-pencil</v-icon
                    >
                    <v-icon small class="mr-2" color="red" @click="deleteItem(item)"
                    >mdi-delete</v-icon
                    >
                </template>
                </v-data-table>
            </td>
        </template>
        <template v-slot:top>
            <CadastroToolbar
                :title="$t('segments.title')"
                :token="token"
                :items="trechos"
                :csv-title="$t('segments.title')"
                :pdf-title="$t('segments.title')"
                :pdf-headers="headersWithProperties"
                pdf-filename="trechos"
                hide-search
            >
                <template v-slot:add v-if="canInsert">
                    <v-dialog
                        v-model="editTrechoDialog"
                        fullscreen
                        max-width="100%"
                    >
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" fab>
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                    </template>

                        <v-card>
                            <v-toolbar dark color="primary" ref="editToolbar">
                                <v-btn icon dark @click="close">
                                    <v-icon>mdi-close</v-icon>
                                </v-btn>
                                <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
                                <v-spacer></v-spacer>
                                <v-toolbar-items>
                                    <v-btn dark text @click="save">{{ $t('button.save') }}</v-btn>
                                </v-toolbar-items>
                            </v-toolbar>

                    <v-card-text>
                        <v-container>
                            <v-form ref="trechoForm" v-model="trechoFormValidado">
                                <v-row>
                                    <v-col cols="12" sm="12" md="6">
                                        <v-text-field
                                            v-model="editedTrecho.descricao_trecho"
                                            :label="$t('segments.description')"
                                            :rules="[(v) => (!!v && v.length <= 150) || $t('segments.required.descriptionRequired')]"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="12" sm="12" md="6">
                                        <v-autocomplete
                                            v-model="editedTrecho.id_linha"
                                            :label="$tc('line.self', 1)"
                                            :items="linhas"
                                            item-text="nome_linha"
                                            item-value="id_linha"
                                            :rules="[(v) => !!v || $t('guide.validation.lineRequired')]"
                                            @input="onLinhaChanged"
                                        ></v-autocomplete>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-autocomplete
                                            v-model="editedTrecho.id_cerca_inicio_trecho"
                                            :label="$t('segments.startGeofence')"
                                            :items="cercas"
                                            item-text="nome_cerca"
                                            item-value="id_cerca"
                                            :loading="loadingCercas"
                                            :rules="[(v) => !!v || $t('segments.required.startGeofenceRequired')]"
                                        ></v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-autocomplete
                                            v-model="editedTrecho.id_cerca_fim_trecho"
                                            :label="$t('segments.endGeofence')"
                                            :items="cercas"
                                            item-text="nome_cerca"
                                            item-value="id_cerca"
                                            :loading="loadingCercas"
                                            :rules="[(v) => !!v || $t('segments.required.endGeofenceRequired')]"
                                        ></v-autocomplete>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="4">
                                        <v-select
                                            v-model="editedTrecho.id_sentido"
                                            :label="$t('operation.direction')"
                                            :items="sentidos"
                                            item-text="descricao_sentido"
                                            item-value="id_sentido"
                                            :rules="[(v) => !!v || $t('segments.required.directionRequired')]"
                                        ></v-select>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12" sm="4" md="4">
                                        <v-switch
                                            v-model="editedTrecho.alarme_velocidade_maxima"
                                            :label="$t('segments.speedAlert')"
                                            color="primary"
                                        ></v-switch>
                                    </v-col>
                                    <v-col cols="12" sm="6" md="6">
                                        <v-text-field
                                            v-model="editedTrecho.velocidade_maxima"
                                            :label="$t('segments.maxSpeed')"
                                            type="number"
                                            min="0"
                                            :rules="[velocidadeRules]"
                                            :disabled="velocidadeDisabled"
                                            @change="alarmeVelocidadeChanged"
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                            </v-form>
                        </v-container>
                        <merus-data-table
                            :headers="headersLimites"
                            :items="limitesTrecho"
                            :loading="loadingLimitesTrecho"
                            :loading-text="$t('segments.loadingLimits')"
                            sort-by="horario_inicio"
                            dense
                            class="elevation-7"
                            locale="pt"
                            style="border-radius: 10px; margin-top: 10px;"
                            cod-tabela="TRECHOS__LIMITES"
                            append-actions
                            actions-i18n-key="segments.headers.actions"
                            @update:headers="headersLimites = $event">
                            <template v-slot:toolbar>
                                <CadastroToolbar
                                    :title="$t('segments.timeLimits')"
                                    :token="token"
                                    :items="limitesTrecho"
                                    hide-search
                                >
                                    <template v-slot:add v-if="canInsert">
                                        <v-dialog
                                            v-model="editLimiteTrechoDialog"
                                            max-width="80%"
                                        >
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn color="primary" dark small class="mb-2" v-bind="attrs" v-on="on" fab>
                                                <v-icon>mdi-plus</v-icon>
                                            </v-btn>
                                        </template>

                                                <v-card>
                                                    <v-card-title color="primary">{{ $t('segments.timeLimits')
                                                        }}</v-card-title>
                                                    <v-card-text>
                                                        <v-container>
                                                            <v-form ref="formLimiteTrecho"
                                                                v-model="formLimiteTrechoValidado">
                                                                <v-row>
                                                                    <v-col cols="12" sm="6" md="3">
                                                                        <v-text-field
                                                                            v-model="editedLimite.horario_inicio"
                                                                            :label="$t('segments.headers.startTime')"
                                                                            v-mask="'##:##'"
                                                                            prepend-inner-icon="mdi-clock"
                                                                            :rules="[(v) => horarioRules(v)]"></v-text-field>
                                                                    </v-col>
                                                                    <v-col cols="12" sm="6" md="3">
                                                                        <v-text-field v-model="editedLimite.horario_fim"
                                                                            :label="$t('segments.headers.endTime')"
                                                                            v-mask="'##:##'"
                                                                            prepend-inner-icon="mdi-clock"
                                                                            :rules="[(v) => horarioRules(v)]"></v-text-field>
                                                                    </v-col>
                                                                    <v-col cols="12" sm="6" md="3">
                                                                        <v-text-field
                                                                            v-model="editedLimite.tempo_minimo"
                                                                            :label="$t('segments.headers.minTime')"
                                                                            type="number" suffix="min" min="0"
                                                                            :rules="[limiteTempoMinimoRules]"></v-text-field>
                                                                    </v-col>
                                                                    <v-col cols="12" sm="6" md="3">
                                                                        <v-text-field
                                                                            v-model="editedLimite.tempo_maximo"
                                                                            :label="$t('segments.headers.maxTime')"
                                                                            type="number" suffix="min" min="0"
                                                                            :rules="[limiteTempoMaximoRules]"></v-text-field>
                                                                    </v-col>
                                                                </v-row>
                                                            </v-form>
                                                        </v-container>
                                                    </v-card-text>

                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn color="primary" dark @click="closeLimiteDialog">{{ $t('button.cancel') }}</v-btn>
                                            <v-btn color="primary" dark @click="saveLimite">{{ $t('button.save') }}</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                    </v-dialog>
                                    </template>
                                </CadastroToolbar>
                            </template>

                            <template v-slot:item.actions="{ item }">
                                <v-icon small class="mr-2" color="green" @click="editLimite(item)">mdi-pencil</v-icon>
                                <v-icon small class="mr-2" color="red" @click="deleteLimite(item)">mdi-delete</v-icon>
                            </template>
                        </merus-data-table>
                    </v-card-text>
                </v-card>
            </v-dialog>
                </template>
            </CadastroToolbar>
        </template>

        <template v-slot:item.actions="{ item }">
            <v-icon small class="mr-2" color="green" @click="editItem(item)" :disabled="!canEdit">mdi-pencil</v-icon>
            <v-icon small class="mr-2" color="red" @click="deleteItem(item)" :disabled="!canDelete">mdi-delete</v-icon>
        </template>
        </merus-data-table>
    </v-container>
</template>
<script>

import apiController from "@/utils/apiController";
import EventBus from "../utils/eventBus";
import CadastroToolbar from './Toolbars/CadastroToolbar.vue';
import MerusDataTable from './Tables/MerusDataTable.vue';
import translateDbField from "@/utils/translateDbField";

export default {
    components: {
        CadastroToolbar,
        MerusDataTable
    },
    data: () => ({
        headersWithProperties: [],
        headersLimites: [],
        user: null,
        token: null,
        loading: false,
        confirmDialog: false,
        confirmMessage: "", 
        loadingCercas: false,
        linhas: [],
        cercas: [],
        sentidos: [],
        trechos: [],

        limites: [],

        editTrechoDialog: false,
        editingTrecho: false,
        trechoFormValidado: false,
        loadingLimitesTrecho: false,
        limitesTrecho: [],
        formLimiteTrechoValidado: false,
        editLimiteTrechoDialog: false,
        editingLimiteTrecho: false,
        editedLimiteIndex: -1,
        editedTrecho: {
            id_trecho: null,
            id_linha: null,
            id_cerca_inicio_trecho: null,
            id_cerca_fim_trecho: null,
            descricao_trecho: null,
            alarme_velocidade_maxima: null,
            velocidade_maxima: null,
            id_sentido: null,
            tempo_minimo_trecho: null,
            tempo_maximo_trecho: null,
            limites: [],
        },
        defaultTrecho: {
            id_trecho: null,
            id_linha: null,
            id_cerca_inicio_trecho: null,
            id_cerca_fim_trecho: null,
            descricao_trecho: null,
            alarme_velocidade_maxima: null,
            velocidade_maxima: null,
            id_sentido: null,
            tempo_minimo_trecho: null,
            tempo_maximo_trecho: null,
            limites: [],
        },
        deletedTrecho: {
            id_trecho: null,
            id_linha: null,
            id_cerca_inicio_trecho: null,
            id_cerca_fim_trecho: null,
            descricao_trecho: null,
            alarme_velocidade_maxima: null,
            velocidade_maxima: null,
            id_sentido: null,
            tempo_minimo_trecho: null,
            tempo_maximo_trecho: null,
            limites: [],
        },
        editedLimite: {
            id_limite: null,
            id_trecho: null,
            horario_inicio: null,
            horario_fim: null,
            tempo_minimo: null,
            tempo_maximo: null,
        },
        defaultLimite: {
            id_limite: null,
            id_trecho: null,
            horario_inicio: null,
            horario_fim: null,
            tempo_minimo: null,
            tempo_maximo: null,
        },
        deletedLimite: {
            id_limite: null,
            id_trecho: null,
            horario_inicio: null,
            horario_fim: null,
            tempo_minimo: null,
            tempo_maximo: null,
        },
        recursos: [],
        canInsert: false,
        canEdit: false,
        canDelete: false,
    }),
    created() {
        this.user = JSON.parse(sessionStorage.getItem("user"));
        this.token = sessionStorage.getItem("api");
        this.populaRecursos();
    },
    computed: {
        formTitle() {
            return this.editingTrecho ? this.$t('segments.editSegment') : this.$t('segments.addSegment');
        },
        headersLimitesFallback() {
            return [
                { text: this.$t('segments.headers.startTime'), value: 'horario_inicio' },
                { text: this.$t('segments.headers.endTime'), value: 'horario_fim' },
                { text: this.$t('segments.headers.minTime'), value: 'tempo_minimo' },
                { text: this.$t('segments.headers.maxTime'), value: 'tempo_maximo' },
                { text: this.$t('segments.headers.actions'), value: "actions", sortable: false },
            ];
        },
        expandedLimitesHeaders() {
            return this.headersLimites.length ? this.headersLimites : this.headersLimitesFallback;
        },
        velocidadeDisabled() {
            return !this.editedTrecho.alarme_velocidade_maxima;
        },
    },
    watch: {
        '$i18n.locale'() {
            this.initialize();
            if (this.$refs.form) {
                this.$refs.form.resetValidation();
            }
        }
    },
    methods: {

        populaRecursos() {
            if (this.user.is_superadmin === 1) {
                apiController.request(apiController.endpoints.getallRecursos, {
                    onSuccess: (response) => {
                        this.recursos = response.data;
                        this.canEdit = true;
                        this.canInsert = true;
                        this.canDelete = true;
                        this.initialize();
                    },
                });
            } else {
                apiController.request(apiController.endpoints.getRecursosusuario, {
                    params: { id: this.user.id_usuario },
                    onSuccess: (response) => {
                        this.recursos = response.data;
                        this.canEdit = this.recursos.some((r) => r.rota === "/api/v1.0/updatetrecho");
                        this.canInsert = this.recursos.some((r) => r.rota === "/api/v1.0/inserttrecho");
                        this.canDelete = this.recursos.some((r) => r.rota === "/api/v1.0/deletetrecho");
                        this.initialize();
                    },
                });
            }
        },
        initialize() {
            this.populaLinhas();
            this.populaSentidos();
            this.populaTrechos();
        },
        populaLinhas() {
            apiController.request(apiController.endpoints.getLinhasativas, {
                onSuccess: (response) => {
                    this.linhas = response.data;
                },
            });
        },
        populaSentidos() {
            apiController.request(apiController.endpoints.getallSentidos, {
                onSuccess: (response) => {
                    this.sentidos = response.data.map((sentido) => {
                        const translated = translateDbField(
                            sentido.translation_key,
                            sentido.descricao_sentido
                        );
                        return {
                            ...sentido,
                            descricao_sentido: translated
                        };
                    });
                },
            });
        },
        onLinhaChanged() {
            if (this.editedTrecho.id_linha) {
                this.populaCercas();
            } else {
                this.cercas = [];
            }
        },
        populaCercas() {
            this.loadingCercas = true;
            apiController.request(apiController.endpoints.getCercasporlinha, {
                data: [this.editedTrecho.id_linha],
                onSuccess: (response) => {
                    this.cercas = response.data;
                    this.loadingCercas = false;
                },
                onError: () => {
                    this.loadingCercas = false;
                },
            });
        },
        populaTrechos() {
            this.loading = true;

            apiController.request(apiController.endpoints.getallTrechos, {
                onSuccess: (response) => {
                    this.trechos = response.data;
                    this.populaLimitesTrechos();
                },
                onError: () => {
                    this.loading = false;
                },
            });
        },
        populaLimitesTrechos() {
            apiController.request(apiController.endpoints.getallTrechoslimites, {
                onSuccess: (response) => {
                    this.limites = response.data;
                    this.trechos = this.trechos.map((t) => {
                        t.limites = this.limites.filter((l) => l.id_trecho === t.id_trecho);
                        return t;
                    });
                    this.loading = false;
                },
                onError: () => {
                    this.loading = false;
                },
            });
        },
        velocidadeRules() {
            if (this.editedTrecho.alarme_velocidade_maxima) {
                if (!this.editedTrecho.velocidade_maxima || this.velocidade_maxima <= 0) {
                    return this.$t('segments.speedGreaterThanZero');
                }
                return true;
            }

            return true;
        },
        horarioRules(hora) {
            if (hora == null) {
                return this.$t('segments.required.timeRequired');
            }
            else {
                if (hora.length === 0) {
                    return this.$t('segments.required.timeRequired');
                }
                else {
                    if (!/(([01][0-9])|(2[0-3])):([0-5][0-9])$/.test(hora)) {
                        return this.$t('datetime.invalidTime');
                    }
                    else {
                        return true;
                    }
                }
            }
        },
        alarmeVelocidadeChanged() {
            if (!this.editedTrecho.alarme_velocidade_maxima) {
                this.editedTrecho.velocidade_maxima = null;
            }
        },
        editItem(item) {
            this.editedTrecho = Object.assign({}, item);
            this.editedTrecho.alarme_velocidade_maxima = !!this.editedTrecho.alarme_velocidade_maxima;
            this.limitesTrecho = this.editedTrecho.limites;
            this.populaCercas();
            this.editingTrecho = true;
            this.editTrechoDialog = true;
        },
        save() {
            this.$refs.trechoForm.validate();
            if (this.trechoFormValidado) {
                if (this.editingTrecho) {
                    apiController.request(apiController.endpoints.updateTrecho, {
                        data: this.editedTrecho,
                        onSuccess: (response) => {
                            this.saveNovosLimites(this.editedTrecho.id_trecho, response);
                        },
                        onError: () => {
                            this.close();
                        },
                    });
                } else {
                    apiController.request(apiController.endpoints.insertTrecho, {
                        data: this.editedTrecho,
                        onSuccess: (response) => {
                            this.saveNovosLimites(response.data.insertId, response);
                        },
                        onError: () => {
                            this.close();
                        },
                    });
                }
            }
        },
        close() {
            this.editedTrecho = Object.assign({}, this.defaultTrecho);
            if (this.$refs.trechoForm) {
                this.$refs.trechoForm.resetValidation();
            }
            this.editingTrecho = false;
            this.cercas = [];
            this.limitesTrecho = [];
            this.editTrechoDialog = false;
        },
        closeConfirmDialog() {
            if (!this.editingLimiteTrecho) {
                this.deletedTrecho = Object.assign({}, this.defaultTrecho);
                this.editingTrecho = false;
            } else {
                this.deletedLimite = Object.assign({}, this.defaultLimite);
                this.editingLimiteTrecho = false;
            }

            this.confirmDialog = false;
            this.confirmMessage = "";
        },
        deleteItem(item) {
            this.deletedTrecho = Object.assign({}, item);
            this.editingTrecho = true;
            this.confirmMessage = `${this.$t('segments.confirmDeleteSegment')} ${this.deletedTrecho.descricao_trecho}?`;
            this.confirmDialog = true;
        },
        editLimite(item) {
            this.editedLimite = Object.assign({}, item);
            this.editedLimiteIndex = this.limitesTrecho.findIndex((l) => l.id_limite == item.id_limite);
            this.editingLimiteTrecho = true;
            this.editLimiteTrechoDialog = true;
        },
        saveLimite() {
            this.$refs.formLimiteTrecho.validate();
            if (this.formLimiteTrechoValidado) {
                let limiteExiste = this.limitesTrecho.findIndex((l) => this.editedLimite.horario_inicio <= l.horario_fim) !== -1;
                if (limiteExiste) {
                    EventBus.$emit('show-error', { error: { message: "Já existe um limite para esse período" } });
                } else { 
                    if (this.editingLimiteTrecho) {
                        apiController.request(apiController.endpoints.updateTrecholimite, {
                            data: this.editedLimite,
                            onSuccess: () => {
                                this.limitesTrecho.splice(this.editedLimiteIndex);
                                this.limitesTrecho.push(Object.assign({}, this.editedLimite));
                                this.closeLimiteDialog();
                            },
                            onError: () => {
                                this.closeLimiteDialog();
                            },
                        });
                    } else {
                        this.limitesTrecho.push(this.editedLimite);
                        this.closeLimiteDialog()
                    }
                }
            }
        },
        saveNovosLimites(idtrecho, resp) {
            let payload = this.limitesTrecho.filter((l) => !l.id_trecho).map((l) => {
                return [idtrecho, l.horario_inicio, l.horario_fim, l.tempo_minimo, l.tempo_maximo];
            });

            if (payload.length > 0) {
                apiController.request(apiController.endpoints.insertTrechoslimitesbulk, {
                    data: payload,
                    onSuccess: (response) => {
                        this.close();
                        this.updateTable(response.data);
                    },
                    onError: () => {
                        this.close();
                    },
                });
            } else {
                this.close();
                this.updateTable(resp.data);
            }

        },
        deleteLimite(item) {
            this.deletedLimite = Object.assign({}, item);
            this.editingLimiteTrecho = true;
            this.editedLimiteIndex = this.limitesTrecho.findIndex((l) => l.id_limite == item.id_limite);
            this.confirmMessage = `${this.$t('segments.confirmDeleteLimit')} ${this.deletedLimite.horario_inicio} h?`;
            this.confirmDialog = true;
        },
        closeLimiteDialog() {
            this.editedLimite = Object.assign({}, this.defaultLimite);
            if (this.$refs.formLimiteTrecho) {
                this.$refs.formLimiteTrecho.resetValidation();
            }
            this.editingLimiteTrecho = false;
            this.editedLimiteIndex = -1;
            this.editLimiteTrechoDialog = false;
        },
        deleteFromDatabase() {
            if (!this.editingLimiteTrecho) {
                apiController.request(apiController.endpoints.deleteTrecho, {
                    data: this.deletedTrecho,
                    onSuccess: (response) => {
                        this.closeConfirmDialog();
                        this.updateTable(response.data);
                    },
                    onError: () => {
                        this.close();
                    },
                });
            } else {
                apiController.request(apiController.endpoints.deleteTrecholimite, {
                    data: this.deletedLimite,
                    onSuccess: () => {
                        this.limitesTrecho.splice(this.editedLimiteIndex);
                        this.closeConfirmDialog();
                    },
                    onError: () => {
                        this.closeConfirmDialog();
                    },
                });
            }
        },
        updateTable(data) {
            const tipo = data.erro ? "error" : "success";
            const mensagem = data.erro ? data.mensagem : this.$t('segments.operationSuccess');
            
            EventBus.$emit('show-alert', { mensagem, tipo });
            this.populaTrechos();
        },
        limiteTempoMinimoRules() {
            if (this.editedLimite.tempo_minimo <= 0) {
                return this.$t('segments.timeGreaterThanZero');
            }

            if (parseInt(this.editedLimite.tempo_minimo) >= parseInt(this.editedLimite.tempo_maximo)) {
                return this.$t('segments.minTimeNotGreaterThanMax');
            }

            return true;
        },
        limiteTempoMaximoRules() {
            if (this.editedLimite.tempo_maximo <= 0) {
                return this.$t('segments.timeGreaterThanZero');
            }

            if (parseInt(this.editedLimite.tempo_minimo) >= parseInt(this.editedLimite.tempo_maximo)) {
                return this.$t('segments.minTimeNotGreaterThanMax');
            }

            return true;
        }
    }
}
</script>
<style></style>